import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { FlowStep, FlowVersion } from '../../../../services/types/Flow';

interface Props {
  steps: FlowStep[];
  currentStep: number;
  versions: FlowVersion[];
  currentVersion: number;
  currentLap: number;
  flowId: number;
}

const FlowCycle2: React.FC<Props> = ({
  steps,
  currentStep,
  versions,
  currentVersion,
  currentLap,
  flowId,
}) => (
  <div className="flow-cycle-wrapper table-responsive">
    <div className="flow-cycle2">
      {steps.map((step, stepIndex) => {
        const versionNumbers = versions
          .filter((v) => v.step === step.id && v.lap === currentLap && v.flowId === flowId)
          .map((v) => v.version)
          .sort((x, y) => Number(x) - Number(y));
        return (
          <Fragment key={`flowcycle2_step_${step.id}`}>
            <div
              className={`step-item ${classnames({
                current: step.id === currentStep,
                previous: step.id < currentStep,
              })}`}
            >
              <div className="name">{step.name}</div>
              <div className="version-container">
                {stepIndex === 0 && (
                  <div className="version-item icon">
                    <FontAwesomeIcon icon="file-word" />
                  </div>
                )}
                {versionNumbers.map((version) => {
                  const maxStep = Math.max(...steps.map((s) => s.id));
                  return (
                    <div
                      key={`version_item_${step.id}_${version}`}
                      className={`version-item ${classnames({
                        current: version === currentVersion,
                        last: step.id === maxStep,
                      })}`}
                    >
                      <div className="flow-line" />
                      <div className="flow-ball" />
                      <div className="version-line" />
                      <div className="version-label">
                        v.{currentLap}.{version}
                      </div>
                      <div className="half-container">
                        <div className="half-flow-line" />
                      </div>
                    </div>
                  );
                })}
                {versionNumbers.length === 0 && (
                  <div className="version-item">
                    <div className="flow-line" />
                  </div>
                )}
                {stepIndex === steps.length - 1 && (
                  <div className="version-item icon last">
                    <FontAwesomeIcon icon="check" />
                  </div>
                )}
              </div>
            </div>
          </Fragment>
        );
      })}
    </div>
  </div>
);

export default FlowCycle2;
